import { useEffect, useRef, useState } from "react";

export default function ATSMottoReact({
  words = [],
  tickMs = 2000,
  heightPx = 200,
  className = "",
}) {
  const [i, setI] = useState(0);
  const [fade, setFade] = useState(true);
  const timerRef = useRef(null);

  useEffect(() => {
    const clear = () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
    clear();

    timerRef.current = setTimeout(() => {
      if (words[i] === words[i + 1]) {
        const next = (i + 1) % words.length;
        setI(next);
        return;
      }

      setFade(false);
      setTimeout(() => {
        const next = (i + 1) % words.length;
        setI(next);
        setFade(true);
      }, 280);
    }, tickMs);

    return clear;
  }, [i, words.length, tickMs, words]);

  const text = words[i] || "";

  return (
    <div
      className={`w-full flex items-center justify-center ${className}`}
      style={{ height: heightPx }}
    >
      <div style={{ transition: "opacity 280ms ease", opacity: fade ? 1 : 0 }}>
        <div
          className="font-extrabold"
          style={{ fontSize: "clamp(28px, 5vw, 64px)", lineHeight: 1.15 }}
        >
          {text}
        </div>
      </div>
    </div>
  );
}
